(() => {
  const init = (footer) => {
    if (!footer || footer.dataset.footerInitialized === 'true') return;
    footer.dataset.footerInitialized = 'true';

    const motionEnabled = footer.dataset.motion === 'true'
      && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!motionEnabled) {
      footer.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        footer.classList.add('is-visible');
        observer.unobserve(footer);
      });
    }, { threshold: .08 });

    observer.observe(footer);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-cosmo-footer]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
